import * as React from 'react';

if (process.env.NODE_ENV === 'production') {
	console.log = function() {};
}

export default ({ element }) => <React.Fragment>{element}</React.Fragment>;
